var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 67.3332C52.4098 67.3332 67.3337 52.4093 67.3337 33.9998C67.3337 15.5903 52.4098 0.666504 34.0003 0.666504C15.5908 0.666504 0.666992 15.5903 0.666992 33.9998C0.666992 52.4093 15.5908 67.3332 34.0003 67.3332Z",
    fill: "#3eb8aa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 20.8685C26.5 20.0698 27.3901 19.5934 28.0547 20.0365L47.7519 33.1679C48.3457 33.5638 48.3457 34.4362 47.7519 34.8321L28.0547 47.9635C27.3901 48.4066 26.5 47.9302 26.5 47.1315V20.8685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.af4738a187a20ee16961a1b3a8950ced.svg";
export { ForwardRef as ReactComponent };